import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useLoginByPhoneContext} from '../LoginByPhoneContext';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import styles from './ButtonLoginByPhone.module.scss';

const ButtonLoginByPhone = () => {
  const {gotCode} = useLoginByPhoneContext();

  return (
    <div className={styles.buttonLoginContainer}>
      <ButtonAction
        variant={'button'}
        type={'submit'}
        label={!gotCode
          ? (
            <FormattedMessage
              id={'login-by-phone-button-get-code'}
              defaultMessage={'Get code'}
            />
          )
          : (
            <FormattedMessage
              id={'login-by-phone-button-login'}
              defaultMessage={'Validate the code'}
            />
          )
        }
        customClassnames={{container: styles.button}}
      />
    </div>
  );
};

export default ButtonLoginByPhone;
